// components/FormBuilder/ComponentTypes/Text/index.tsx

import React from 'react';
import { Card, Input, Space, Button } from 'antd';
import { DeleteOutlined, UpOutlined, DownOutlined, DragOutlined } from '@ant-design/icons';
import { SortableHandle } from 'react-sortable-hoc';
import { Select } from 'antd';
import { Checkbox } from 'antd';
import { Typography } from 'antd';

const DragHandle = SortableHandle(() => <DragOutlined style={{ cursor: 'move' }} size={18} />);

export const TextInput = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    {/* Short Answer */}
                    <Typography.Paragraph>Short Answer</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Text Answer)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Space direction="horizontal" style={{ width: '100%' }}>
                        <Select
                            defaultValue={component['input-type'] || 'text'}
                            style={{ minWidth: 120 }}
                            onChange={(value) => onChange({ ...component, 'input-type': value })}
                        >
                            <Select.Option value="text">Text</Select.Option>
                            <Select.Option value="number">Number</Select.Option>
                            <Select.Option value="email">Email</Select.Option>
                            <Select.Option value="password">Password</Select.Option>
                            <Select.Option value="passcode">Passcode</Select.Option>
                            <Select.Option value="phone">Phone</Select.Option>
                        </Select>

                        <Input
                            style={{
                                width: '100%',
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                            showCount
                            maxLength={20}
                            size="small"
                            value={component.label}
                            onChange={(e) => onChange({ ...component, label: e.target.value })}
                            placeholder="Label"
                            required
                        />
                    </Space>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        value={component['helper-text']}
                        size="small"
                        showCount
                        maxLength={80}
                        onChange={(e) => onChange({ ...component, 'helper-text': e.target.value })}
                        placeholder="Instructions (optional)"
                    />
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};

export const TextArea = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Paragraph</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Text Answer)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={20}
                        size="small"
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        value={component['helper-text']}
                        size="small"
                        showCount
                        maxLength={80}
                        onChange={(e) => onChange({ ...component, 'helper-text': e.target.value })}
                        placeholder="Instructions (optional)"
                    />
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};

export const DatePicker = ({ component, onChange, onDelete }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    return (
        <Card
            size="small"
            draggable
            title={
                <Space direction="horizontal" align="center">
                    <DragHandle />
                    <Typography.Paragraph>Date Picker</Typography.Paragraph>
                    <Typography.Paragraph disabled type="secondary">
                        (Text Answer)
                    </Typography.Paragraph>
                </Space>
            }
            extra={
                <Space direction="horizontal">
                    <Button icon={<DeleteOutlined />} onClick={() => onDelete(component.id)} type="text" danger />
                </Space>
            }
        >
            {!collapsed && (
                <Space direction="vertical" style={{ width: '100%' }}>
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        showCount
                        maxLength={20}
                        size="small"
                        value={component.label}
                        onChange={(e) => onChange({ ...component, label: e.target.value })}
                        placeholder="Label"
                        required
                    />
                    <Input
                        style={{
                            width: '100%',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                        value={component['helper-text']}
                        size="small"
                        showCount
                        maxLength={80}
                        onChange={(e) => onChange({ ...component, 'helper-text': e.target.value })}
                        placeholder="Instructions (optional)"
                    />
                    <Checkbox
                        checked={component.required}
                        onChange={(e) => onChange({ ...component, required: e.target.checked })}
                    >
                        Required
                    </Checkbox>
                </Space>
            )}
        </Card>
    );
};
